import React from 'react'

import {Box} from '@mui/material'

import Navigation, {
  type NavigationItem,
} from '@progyny/pages/Consultations/Program/components/Navigation'

export interface ConsultationHubNavigationRowProps {
  items: NavigationItem[]
  activeItemID: string
  onItemClick: (itemID: string) => void
  colors?: any
  /** e.g. filter dropdown on upcoming/past */
  endAdornment?: React.ReactNode
}

const rowSx = {
  marginBottom: 3,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 2,
  width: '100%',
} as const

const ConsultationHubNavigationRow: React.FC<
  ConsultationHubNavigationRowProps
> = ({items, activeItemID, onItemClick, colors, endAdornment}) => (
  <Box sx={rowSx}>
    <Navigation
      items={items}
      activeItemID={activeItemID}
      onItemClick={onItemClick}
      colors={colors}
    />
    {endAdornment}
  </Box>
)

export default ConsultationHubNavigationRow
